import { APIModel } from '@shared/interfaces';
import { PollingStatus } from './polling-status.enum';
import { StatusProvider } from './status-provider.enum';

export enum ExportType {
    SAVE = 'save',
    SUBMIT = 'submit'
}
 
export class PersonalTaxExport implements APIModel {
    id = -1;
    url?: string;
    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    type = ExportType.SAVE;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.url = data.url ?? undefined;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.type = data.type ?? ExportType.SAVE;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            url: this.url,
            status: this.status,
            status_message: this.statusMessage,
            status_message_provider: this.statusMessageProvider,
            type: this.type,
        };
    }
}
